import {
  requestExchangeCardList,
  requestExchangeCardCheck,
  requestExchangeCardExchange,
} from '@/api/exchangeCard';

const state = {
  exchangeCardList: null,
  exchangeCheckResult: null,
  exchangeResult: null,
};

const getters = {
  exchangeCardList: (state) => state.exchangeCardList,
  exchangeCheckResult: (state) => state.exchangeCheckResult,
  exchangeResult: (state) => state.exchangeResult,
};

const actions = {
  async setExchangeCardList({ commit, dispatch, rootGetters }, { postParams, pageNumber }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestExchangeCardList({ csrfToken, postParams, pageNumber });
    commit('setExchangeCardList', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    await dispatch('setIsLoading', false, { root: true });
  },
  async setExchangeCheckResult({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestExchangeCardCheck({ csrfToken, postParams });
    commit('setExchangeCheckResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  clearExchangeCardList({ commit }) {
    commit('setExchangeCardList', null);
  },
  clearExchangeCheckResult({ commit }) {
    commit('setExchangeCheckResult', null);
  },
  async exchange({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestExchangeCardExchange({ csrfToken, postParams });
    commit('setExchangeResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  clearExchangeResult({ commit }) {
    commit('setExchangeResult', null);
  },
};

const mutations = {
  setExchangeCardList(state, exchangeCardList) {
    state.exchangeCardList = exchangeCardList;
  },
  setExchangeCheckResult(state, exchangeCheckResult) {
    state.exchangeCheckResult = exchangeCheckResult;
  },
  setExchangeResult(state, exchangeResult) {
    state.exchangeResult = exchangeResult;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
